module.exports = __webpack_public_path__ + "img/tick.c83bc462.svg";